import { useEffect, useState } from "react";
import { useAuth } from "../../lib/auth.js";
import { useT } from "../../lib/i18n.js";
import { errorMessage, trpcClient } from "../../lib/trpc.js";
import { Button } from "../../components/ui/Button.js";
import { Field } from "../../components/ui/Field.js";
import { Input } from "../../components/ui/Input.js";

export function EmailRecoverySection() {
  const t = useT();
  const { user } = useAuth();
  const [status, setStatus] = useState<{ enabled: boolean; email: string | null } | null>(null);
  const [password, setPassword] = useState("");
  const [totpCode, setTotpCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  async function refresh() { setStatus(await trpcClient.emailRecovery.status.query()); }
  useEffect(() => {
    let current = true;
    void trpcClient.emailRecovery.status.query().then(value => { if (current) setStatus(value); }).catch(cause => { if (current) setError(errorMessage(cause)); });
    return () => { current = false; };
  }, [user?.email]);
  return <div className="fc-recovery__form">
    <h3>{t("Email recovery")}</h3>
    <p>{t("Email recovery lets you reset your password without a group member. It restores sign-in, but cannot open old group photos. Keep a recovery file too.")}</p>
    {status && <p role="status">{status.enabled ? t("Email recovery enabled for") + ": " + status.email : t("Email recovery is not enabled yet.")}</p>}
    <p>{t("Changing your account email disables email recovery. Enable it again and confirm the new address.")}</p>
    {user?.email ? <form className="fc-recovery__form" onSubmit={event => { event.preventDefault(); setBusy(true); setError(null);
      void trpcClient.emailRecovery.enable.mutate({ password, totpCode: totpCode || undefined }).then(() => { setSent(true); setPassword(""); setTotpCode(""); }).catch(cause => setError(errorMessage(cause))).finally(() => setBusy(false));
    }}>
      <p>{t("Confirmation will be sent to")}: <strong>{user.email}</strong></p>
      <Field label={t("Current password")} required><Input type="password" autoComplete="current-password" value={password} disabled={busy} required onChange={event => setPassword(event.target.value)} /></Field>
      {user.totpEnabled && <Field label={t("Authenticator code")} required><Input value={totpCode} inputMode="numeric" autoComplete="one-time-code" maxLength={6} disabled={busy} required onChange={event => setTotpCode(event.target.value.replace(/\D/g, ""))} /></Field>}
      <Button type="submit" variant="secondary" loading={busy}>{t("Enable email recovery")}</Button>
      {sent && <p role="status">{t("Open the confirmation email to enable recovery. Then refresh the status here.")}</p>}
    </form> : <p>{t("Add an email address to your account first.")}</p>}
    <Button variant="secondary" disabled={busy} onClick={() => { setError(null); void refresh().catch(cause => setError(errorMessage(cause))); }}>{t("Refresh email recovery status")}</Button>
    {error && <p role="alert" className="fc-auth__error">{error}</p>}
  </div>;
}
